import { AuthTopNavigation } from '~/@pages_auth/auth-top-navigation/AuthTopNavigation'
import { RegistrationOverview } from '~/@pages_auth/register/register_ui/RegistrationOverview'
import type { RegisterRequest } from './register-form/useRegister'
import { RegisterForm } from './register-form/RegisterForm'

type Props = {
  isRegistering: boolean
  handleRegisterUser: (data: RegisterRequest) => void
  error: string | null
  title?: string
  description?: string
}

function RegistrationComponent({
  isRegistering,
  handleRegisterUser,
  error,
  title,
  description,
}: Props) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="flex items-start col-span-1">
        <div className="flex flex-col justify-center items-center gap-0 lg:gap-[60px] w-full">
          <AuthTopNavigation />
          <div className="flex flex-col gap-10 lg:gap-6 w-full lg:w-[400px] md:px-5 lg:px-0 lg:py-auto ">
            <RegisterForm
              title={title}
              description={description}
              isRequesting={isRegistering}
              handleSubmitForm={handleRegisterUser}
              error={error}
            />
          </div>
        </div>
      </div>
      <div className="hidden lg:flex lg:col-span-1 justify-center items-center md:px-20 bg-foreground text-primary-foreground">
        <RegistrationOverview isCompany={false} />
      </div>
    </div>
  )
}

export default RegistrationComponent
